import { render, staticRenderFns } from "./InternationalWire.vue?vue&type=template&id=1a27890e&scoped=true&"
import script from "./InternationalWire.vue?vue&type=script&lang=js&"
export * from "./InternationalWire.vue?vue&type=script&lang=js&"
import style0 from "./InternationalWire.vue?vue&type=style&index=0&id=1a27890e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a27890e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a27890e')) {
      api.createRecord('1a27890e', component.options)
    } else {
      api.reload('1a27890e', component.options)
    }
    module.hot.accept("./InternationalWire.vue?vue&type=template&id=1a27890e&scoped=true&", function () {
      api.rerender('1a27890e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/panels/InternationalWire.vue"
export default component.exports